var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClothSeats32 = function SvgClothSeats32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.139 2h5.396c.496-.001.978.172 1.365.49.387.32.655.764.76 1.262.595 2.872 2.634 8.416 9.605 9.843.49.102.93.375 1.246.772.316.397.49.894.489 1.406v12.004c0 .59-.229 1.155-.635 1.572A2.142 2.142 0 0 1 23.83 30H7.169a2.143 2.143 0 0 1-1.534-.651A2.251 2.251 0 0 1 5 27.777V4.214a2.251 2.251 0 0 1 .628-1.555c.4-.414.942-.65 1.51-.659v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.003 5S11.538 15.11 22 18.303V27",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.67 4.58 3.67 4.58 3.67 4.58"
  })));
};
export default SvgClothSeats32;